import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import {
  Video,
  Sun,
  BookOpen,
  Users,
  GraduationCap,
  Calendar,
  Handshake,
  Star,
} from "lucide-react";

const AnimatedBlock = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const offerings = [
  {
    icon: Video,
    title: "1 Live Mensile di Formazione",
    desc: "Temi di crescita personale e spirituale: shadow work, leadership, autostima, human design, missione di vita, ferite dell'anima e molto altro.",
  },
  {
    icon: Sun,
    title: "1 Cerchio di Luce Live",
    desc: "Un cerchio di Luce mensile potentissimo con pratiche e rituali di gruppo per radicare ed espandere il tuo Guerriero di Luce.",
  },
  {
    icon: BookOpen,
    title: "Libreria delle Pratiche",
    desc: "Pratiche meditative, visualizzazioni, pratiche energetiche e somatiche, audio di riprogrammazione subconscio e pratiche di embodiment.",
  },
  {
    icon: Users,
    title: "Community Privata",
    desc: "Accesso alla community su Telegram per fare rete con i tuoi compagni di viaggio. Supporto continuativo ogni giorno.",
  },
  {
    icon: GraduationCap,
    title: "Workshop con Professionisti",
    desc: "Psicologi, Human Design Teachers, ArteTerapeuti, Insegnanti di Yoga, Naturopati, Astrologi e molti altri esperti.",
  },
  {
    icon: Calendar,
    title: "Eventi dal Vivo",
    desc: "Durante l'anno eventi dal vivo con temi specifici ed eventi di community a cui partecipare con contributi agevolati.",
  },
  {
    icon: Handshake,
    title: "Networking",
    desc: "Opportunit\u00e0 di networking e connessione professionale con altri membri. Molti partecipanti sono liberi professionisti in espansione.",
  },
  {
    icon: Star,
    title: "Scontistica Esclusiva",
    desc: "Accesso riservato a prezzi speciali sui percorsi individuali e le sessioni one-to-one con Stella Soul Coach. Un vantaggio unico per i/le membri di Light Workers House.",
  },
];

const OfferingsSection = () => {
  return (
    <section
      id="membership"
      data-testid="offerings-section"
      className="py-24 md:py-32 bg-[#ECEAE6]"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <AnimatedBlock>
          <div className="text-center mb-16">
            <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-[#442F23] mb-6 uppercase">
              Cosa comprende il percorso Light Workers House
            </h2>
            <div className="section-divider mb-6" />
          </div>
        </AnimatedBlock>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {offerings.map((item, i) => {
            const Icon = item.icon;
            return (
              <AnimatedBlock key={item.title} delay={i * 0.08}>
                <div
                  className="bg-[#FBF8E9] border border-[#AC8E60]/15 rounded-[1.5rem] p-8 card-hover h-full"
                  data-testid={`offering-card-${i}`}
                >
                  <div className="w-12 h-12 rounded-full bg-[#E1C340]/15 flex items-center justify-center mb-5">
                    <Icon size={22} className="text-[#AC8E60]" />
                  </div>
                  <h3 className="font-heading text-xl font-semibold text-[#442F23] mb-3">
                    {item.title}
                  </h3>
                  <p className="font-body text-sm text-[#442F23]/70 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </AnimatedBlock>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OfferingsSection;
